import {
  CardMarketPriceStrategyRequestType,
  CardTraderPriceStrategyResponseType,
  CardTraderPriceStrategyRequestType,
  CardMarketPriceStrategyResponseType,
} from "magic-shared-types";
import { api } from "../api";
import { BASE_SERVER_PATH } from "../../constant";

export const myServerApis = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllCardMarketPriceStrategy: builder.query<
      CardMarketPriceStrategyResponseType[],
      void
    >({
      query: () => ({
        url: `${BASE_SERVER_PATH}/api/card-market-price-strategy/all`,
        method: "GET",
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
    getAllCardTraderPriceStrategy: builder.query<
      CardTraderPriceStrategyResponseType[],
      void
    >({
      query: () => ({
        url: `${BASE_SERVER_PATH}/api/card-trader-price-strategy/all`,
        method: "GET",
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
    createCardMarketPriceStrategy: builder.mutation<
      { success: true },
      CardMarketPriceStrategyRequestType
    >({
      query: (body) => ({
        url: `${BASE_SERVER_PATH}/api/card-market-price-strategy/create`,
        method: "POST",
        body,
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
    createCardTraderPriceStrategy: builder.mutation<
      { success: true },
      CardTraderPriceStrategyRequestType
    >({
      query: (body) => ({
        url: `${BASE_SERVER_PATH}/api/card-trader-price-strategy/create`,
        method: "POST",
        body,
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
    deletePriceStrategyCardTrader: builder.mutation<
      { success: true },
      { strategyId: number }
    >({
      query: ({ strategyId }) => ({
        url: `${BASE_SERVER_PATH}/api/card-trader-price-strategy/${strategyId}`,
        method: "DELETE",
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
    deletePriceStrategyCardMarket: builder.mutation<
      { success: true },
      { strategyId: number }
    >({
      query: ({ strategyId }) => ({
        url: `${BASE_SERVER_PATH}/api/card-market-price-strategy/${strategyId}`,
        method: "DELETE",
        headers: {
          "x-requires-auth": "true",
        },
      }),
    }),
  }),
});

export const {
  useCreateCardMarketPriceStrategyMutation,
  useCreateCardTraderPriceStrategyMutation,
  useGetAllCardMarketPriceStrategyQuery,
  useGetAllCardTraderPriceStrategyQuery,
  useDeletePriceStrategyCardTraderMutation,
  useDeletePriceStrategyCardMarketMutation,
} = myServerApis;
